import { handleActions } from 'redux-actions';

import { setLinksLength, setLinks } from '../actions/mw_links';

const initialState = {
  links: [],
  linksLength: 10,
};

export default handleActions(
  {
    [setLinks]: (state, { payload: { links } }) => ({
      ...state,
      links,
    }),
    [setLinksLength]: (state, { payload: { linksLength } }) => ({
      ...state,
      linksLength,
    }),
  },
  initialState
);
